module.exports = __webpack_public_path__ + "static/img/i46.5564fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/i46.jpg
// module id = z3rq
// module chunks = 3